import type { CityConfig } from "../city-template/types";

export const auroraCoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Colorado Dept of Public Health Vital Records", href: "https://cdphe.colorado.gov/vital-records", description: "Official Colorado vital records office in Denver" },
    { label: "Marriage Licenses — Arapahoe County Clerk", href: "https://www.arapahoegov.com/", description: "Arapahoe County Clerk — marriage license issuance" },
    { label: "Divorce Records — Arapahoe County Clerk", href: "https://www.arapahoegov.com/", description: "Arapahoe County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of CDPHE for online vital record orders" },
  ],
  city: "Aurora",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "aurora-co",
  route: "/aurora-co",
  title: "Emergency Passport Aurora, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Aurora, CO — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Aurora and Arapahoe County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Aurora, CO",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Aurora and Arapahoe County travelers get their expedited passports as quickly as 24 hours. Home to the Colorado Passport Agency, Aurora is Colorado's passport hub — but lines are long and appointments scarce. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aurora%20Colorado%20cityscape%20at%20golden%20hour%20with%20Denver%20skyline%20visible%20in%20the%20background%2C%20Arapahoe%20County%20suburban%20landscape%2C%20modern%20shopping%20centers%20and%20residential%20neighborhoods%2C%20Rocky%20Mountains%20silhouette%20in%20the%20distance%2C%20warm%20golden%20light%20over%20the%20Front%20Range%20plains%2C%20professional%20aerial%20cityscape%20photography%2C%20warm%20amber%20and%20golden%20tones%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=aurora-co-hero-001&orientation=landscape",
  heroImageAlt: "Aurora Colorado cityscape at golden hour with Denver skyline and Rocky Mountains in the background",
  geoPosition: "39.7294;-104.8319",
  geoPlacename: "Aurora, Colorado",
  lastModified: "2026-06-03",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Located right in Aurora — but appointments are extremely limited and often unavailable for weeks",
  },
  nearbyCitiesZips: [
    { name: "Central Aurora", zips: "80010, 80011, 80012" },
    { name: "South Aurora", zips: "80013, 80014, 80015" },
    { name: "East Aurora", zips: "80016, 80017, 80018" },
    { name: "Town Center", zips: "80014, 80015" },
    { name: "Centennial", zips: "80112, 80121, 80122" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Englewood", zips: "80110, 80111, 80113" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Cherry Hills Village", zips: "80113, 80121" },
    { name: "Foxfield", zips: "80016" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Aurora departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Denver", route: "/denver" },
    { name: "Emergency passport help in Colorado Springs", route: "/colorado-springs" },
    { name: "Urgent passport services in Boulder", route: "/boulder" },
    { name: "Same-day passport help in Centennial", route: "/aurora-co" },
    { name: "Expedited passport services in Parker", route: "/aurora-co" },
    { name: "Passport courier services in Englewood", route: "/aurora-co" },
    { name: "Rush passport help in Highlands Ranch", route: "/aurora-co" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Aurora remotely via secure courier. We do not operate a walk-in office in Aurora — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Even though the Colorado Passport Agency is located in Aurora, getting an appointment there is notoriously difficult. Our courier service bypasses the appointment process entirely.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Aurora, Arapahoe County, and the southeast Denver metro",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Aurora and the southeast Denver metro. Aurora is home to the Colorado Passport Agency — but appointment availability is extremely limited, often booked weeks out. Our registered courier service is the most reliable way to get your passport fast without fighting for an appointment.",
  nearbyCitiesIntro: "We serve all Aurora zip codes and surrounding communities including Centennial, Parker, Englewood, Highlands Ranch, and Lone Tree. If you are in Arapahoe County or the southeast Denver metro, we have you covered.",
  howItWorksIntro: "Most Aurora travelers complete everything online and ship documents overnight. You do not need to compete for a scarce Regional Agency appointment. Our emergency and expedited passport process is designed for Aurora travelers who need fast, reliable results.",
  mistakesIntro: "Aurora has one of the busiest passport environments in Colorado — and the most common mistakes here cost travelers their appointment slots. Here is what we see most often.",
  testimonialsIntro: "Aurora travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Aurora? Here are the most common ones we hear from Arapahoe County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Aurora international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Aurora.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "South Aurora, CO",
      rating: 5,
      text: "My flight to Mexico City was in 3 days and I discovered my passport expired. Even with the Regional Agency nearby in Aurora, I couldn't get an appointment. Fast Passport Center got my renewal done in 36 hours. Saved my family vacation.",
      service: "Emergency Passport",
    },
    {
      name: "Kevin L.",
      location: "Town Center, Aurora",
      rating: 5,
      text: "Needed to renew for a business trip to London and couldn't get a Regional Agency appointment in time. Fast Passport Center had my passport back to me in 5 days. Professional and reliable.",
      service: "Passport Renewal",
    },
    {
      name: "Sandra T.",
      location: "Centennial, CO",
      rating: 5,
      text: "Lost my passport before a conference trip to Germany. They guided me through the DS-64 process and had a replacement ready in 2 days. No Regional Agency appointment nightmare.",
      service: "Lost Passport",
    },
    {
      name: "James W.",
      location: "East Aurora, CO",
      rating: 5,
      text: "I travel internationally for work every quarter and Fast Passport Center always delivers. Faster than fighting for a Regional Agency slot and significantly cheaper than FedEx courier services.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "aur-1",
      name: "Aurora Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9995 E. Colfax Ave",
      city: "Aurora",
      state: "CO",
      zip: "80010",
      phone: "(303) 363-3481",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Aurora Hills area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "One of the busiest passport acceptance locations in Aurora. Appointments fill quickly — book 2+ weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-2",
      name: "Aurora South Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16890 E. Alameda Pkwy",
      city: "Aurora",
      state: "CO",
      zip: "80017",
      phone: "(303) 360-6270",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.2 miles from Aurora Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "South Aurora location. Appointment strongly recommended. Photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-3",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7585 S. Yosemite St",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(720) 488-1380",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Centennial Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Centennial and south Aurora residents. Call ahead for weekend availability.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-4",
      name: "Parker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10840 S. Parker Rd",
      city: "Parker",
      state: "CO",
      zip: "80134",
      phone: "(303) 841-3200",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.4 miles from Parker Mainstreet",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-5",
      name: "Englewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4901 S. Windermere St",
      city: "Englewood",
      state: "CO",
      zip: "80110",
      phone: "(303) 781-2370",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Englewood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Englewood and south Denver residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "aur-6",
      name: "Arapahoe County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "5334 S. Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 795-4580",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "3 miles from Aurora Town Center",
      website: "https://www.arapahoegov.com/",
      websiteLabel: "Arapahoe County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — limited slots, often booked weeks out", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare emergency)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Must appear in person at Aurora office", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Aurora photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background. A rejected photo means a cancelled appointment.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Aurora acceptance facilities. One error means rescheduling weeks out.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Aurora applicants show up with incorrect checks and have to reschedule their appointment entirely.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver Regional Agency will turn you away — even though it's right in Aurora.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Aurora families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Aurora travelers often assume they can just walk into the Regional Agency. Appointments are booked weeks out. Start expedited processing as soon as you confirm travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Aurora." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Aurora address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "The Colorado Passport Agency is in Aurora — can I just walk in?",
      a: "No — the Colorado Passport Agency at 3151 S. Vaughn Way in Aurora does not accept walk-ins. You must have a pre-scheduled appointment, and those appointments are extremely limited and often unavailable for weeks. Fast Passport Center's courier service bypasses the appointment process entirely, providing 24–48 hour emergency processing without competing for scarce agency slots.",
    },
    {
      q: "How fast can I get an emergency passport in Aurora?",
      a: "Fast Passport Center offers emergency passport processing in Aurora in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Aurora travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Aurora?",
      a: "Same-day passports at the Denver Regional Agency in Aurora are only available for documented life-or-death emergencies. For all other urgent travel — business trips, family vacations, cruise departures — Fast Passport Center's 24–48 hour emergency courier processing is your best option.",
    },
    {
      q: "Where can I get a fast passport renewal in Aurora?",
      a: "Fast Passport Center offers fast passport renewal in Aurora with no office visit required. We serve all Aurora zip codes. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Aurora?",
      a: "The fastest way to get an urgent passport in Aurora is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than competing for a Regional Agency appointment.",
    },
    {
      q: "What if I live in Centennial, Parker, or Englewood?",
      a: "We serve all of Arapahoe County and surrounding communities including Centennial, Parker, Englewood, Highlands Ranch, and Lone Tree. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Aurora?",
      a: "Popular options include Aurora Hills Post Office (80010), Aurora South Post Office (80017), Centennial Post Office (80112), and Arapahoe County Clerk (80120). All require appointments. We help you find the most convenient location.",
    },
    {
      q: "How much does expedited passport service cost in Aurora?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Aurora?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Aurora offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Aurora?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Aurora?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Aurora families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is Fast Passport Center cheaper than going directly to the Regional Agency?",
      a: "In most cases, yes — especially when you factor in the time cost of competing for agency appointments, potential rejected applications requiring resubmission, and lost travel opportunities. Our best price guarantee means we're typically 30–100% less expensive than FedEx, Staples, and other third-party resellers.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Aurora", address: "12345 E. Colfax Ave, Aurora, CO 80011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Town Center", address: "15820 E. Hampden Ave, Aurora, CO 80016", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Aurora", address: "2985 S. Peoria St, Aurora, CO 80014", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "UPS Store — Centennial", address: "7560 S. University Blvd, Centennial, CO 80122", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Aurora", address: "3301 N. Tower Rd, Aurora, CO 80011", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Costco — Parker", address: "19399 E. Main St, Parker, CO 80138", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
    { name: "Walgreens — Englewood", address: "300 W. Hampden Ave, Englewood, CO 80110", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Highlands Ranch", address: "9360 Dorchester St, Highlands Ranch, CO 80129", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "DMV — Aurora",
      address: "14391 E. 4th Ave, Aurora, CO 80011",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Centennial",
      address: "1881 W. Littleton Blvd, Littleton, CO 80120",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves south Aurora and Centennial residents. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Parker",
      address: "11177 S. Parker Rd, Parker, CO 80134",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Englewood",
      address: "4800 S. Logan St, Englewood, CO 80113",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center. Extended hours available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "25 miles from Aurora via I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "The primary international airport for Aurora and the southeast Denver metro. Direct access via I-70 from Aurora.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "75 miles from Aurora via I-25",
      address: "7770 Milton E. Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport alternative for southern Colorado connections.",
      flightUrl: "https://www.coloradosprings.gov/airport",
      flightLabel: "Colorado Springs Airport",
      featured: false,
    },
  ],
};